import React from "react";

interface ExternalLinkProps {
	href: string
	children: React.ReactNode
	className?: string
	newTab?: boolean
}

export default function ExternalLink({
																			 href,
																			 children,
																			 className = "",
																			 newTab = true,
																		 }: ExternalLinkProps) {
	return (
		<a
			href={href}
			target={newTab ? "_blank" : undefined}
			rel={newTab ? "noopener noreferrer" : undefined}
			className={`text-blue-600 hover:underline ${className}`}
		>
			{children}
		</a>
	)
}
